Greenmile.EventNotifications = Greenmile.EventNotifications || {};

Greenmile.EventNotifications.window = Greenmile.EventNotifications.window || {};

const createTab = (entity, id, tabResourceId, ul) => {
    const tabId = `${entity}_event_notification_${id}`;
    const selector = `#${tabId}`;
    const oldDiv = document.querySelector(selector);

    const div = document.createElement('div');
    div.setAttribute('id', tabId);

    const li = document.createElement('li');
    const a = document.createElement('a');
    a.setAttribute('href', selector);
    a.innerHTML = Monet.I18n.getResourcesByKey(tabResourceId);
    li.appendChild(a);
    ul.appendChild(li);

    return div;
};

Greenmile.EventNotifications.window.CreateTabStructure = (eventLog, entity) => {
    const model = { ...eventLog, entity };
    const { stop, route, equipment, driver, eventLogNotes, eventLogDrivers } = model;

    const divTabs = document.createElement('div');
    const ul = document.createElement('ul');
    divTabs.className = 'event_notification_tabs';
    divTabs.appendChild(ul);

    let drivers = [];

    if (route && route.id) {
        const routeTab = createTab(entity, 'route', 'eventLog.route', ul);
        const routeTableView = new Greenmile.EventNotifications.Route.TableView(route, model.id);
        routeTab.appendChild(routeTableView.getRouteTabContent());
        divTabs.appendChild(routeTab);

        const driverAssignments = route.driverAssignments;
        if (driverAssignments && driverAssignments.length) {
            for (var i = 0, length = driverAssignments.length; i < length; i++) {
                drivers.push(driverAssignments[i].driver);
            }
        }
    }

    if (driver && driver.id) {
        const isDriverAssigned = drivers.some(assignedDriver => assignedDriver.id === driver.id);
        
        if (!isDriverAssigned) {
            drivers.push(driver);
        }
    }

    if (drivers && drivers.length > 0) {
        const driverTab = createTab(entity, 'driver', 'eventLog.driver', ul);
        const driverTableView = new Greenmile.EventNotifications.Driver.TableView(drivers);
        driverTableView.setEquipment(equipment);
        driverTab.appendChild(driverTableView.getDriversTabContent());
        divTabs.appendChild(driverTab);
    }

    if (stop && stop.id) {
        const stopTab = createTab(entity, 'stop', 'eventLog.stop', ul);
        const stopTableView = new Greenmile.EventNotifications.Stop.TableView(stop);
        stopTab.appendChild(stopTableView.getStopTabContent());
        divTabs.appendChild(stopTab);
    }

    if (equipment && equipment.id) {
        const equipmentTab = createTab(entity, 'equipment', 'eventLog.equipment', ul);
        const equipmentTableView = new Greenmile.EventNotifications.Equipment.TableView(equipment, eventLog.id);
        equipmentTab.appendChild(equipmentTableView.getEquipmentTabContent());
        divTabs.appendChild(equipmentTab);
    }
    
    if (eventLogDrivers && eventLogDrivers.length > 0) {
        const driversTab = createTab(entity, 'drivers', 'eventLog.eventLogDrivers', ul);
        const driversTableView = new Greenmile.EventNotifications.Drivers.TableView(eventLogDrivers);
        driversTab.appendChild(driversTableView.getDriversTabContent());
        divTabs.appendChild(driversTab);
    }

    if (eventLogNotes && eventLogNotes.length) {
        const eventLogNotesTab = createTab(entity, 'eventLogNotes', 'eventLog.popUp.eventLogNotes.comment', ul);
        const eventLogNotesTableView = new Greenmile.EventNotifications.EventLogNotes.TableView(eventLogNotes);
        eventLogNotesTab.appendChild(eventLogNotesTableView.getEventLogNotesTabContent());
        divTabs.appendChild(eventLogNotesTab);                             
    }

    const coordsTab = createTab(entity, 'coordinate', 'eventLog.coordinate', ul);
    coordsTab.appendChild(new Greenmile.EventNotifications.Coordinate.TableView(eventLog).getCoordinateTabContent());
    divTabs.appendChild(coordsTab);

    return divTabs;

};
